import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

let state = { loaded: false, pending: false };
const subs = new Set();
const emit = () => subs.forEach((f) => f(state));

let inflight = null;
export const refreshWbStatus = () =>
  (inflight ||= api.get("/wellbeing")
    .then((r) => { state = { loaded: true, pending: !r.data?.this_week }; emit(); })
    .catch(() => {})
    .finally(() => { inflight = null; }));

export const useWbPending = () => {
  const [s, setS] = useState(state);
  useEffect(() => {
    subs.add(setS);
    if (!state.loaded && !inflight) refreshWbStatus();
    return () => subs.delete(setS);
  }, []);
  return s.loaded && s.pending;
};

export const WbDot = ({ className }) => (
  <span className={cn("h-2 w-2 rounded-full bg-[#D4AF37] shadow-[0_0_6px_rgba(212,175,55,0.8)]", className)} data-testid="wb-checkin-dot" />
);

export const WbHeartPill = () => {
  const pending = useWbPending();
  return (
    <Link to="/wellbeing" data-testid="wb-heart-pill"
      className={cn("flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold transition-colors",
        pending ? "wb-heartbeat bg-[#D4AF37] text-[#09090B] hover:bg-[#F3C649]" : "border border-[#D4AF37]/50 bg-[#33290D] text-[#F3C649] hover:bg-[#3d3110]")}>
      <Heart className="h-3.5 w-3.5" fill={pending ? "currentColor" : "none"} />
      <span data-testid="wb-heart-pill-label">{pending ? "Check in" : "Well-Being"}</span>
    </Link>
  );
};

export const RejectedBanner = () => (
  <div className="mb-3 rounded-lg border border-[#D4AF37]/30 bg-[#33290D]/60 p-3 text-xs leading-relaxed text-zinc-300" data-testid="tracker-rejected-banner">
    <div className="flex gap-2"><Heart className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#D4AF37]" fill="currentColor" /><span>A “no” is an employer’s decision, not your worth.</span></div>
    <Link to="/wellbeing/journey/jr_resilient" className="mt-2 block font-medium text-[#F3C649] hover:underline" data-testid="tracker-rejected-journey-link">Take five minutes with “Becoming Resilient” →</Link>
  </div>
);
